import { render, staticRenderFns } from "./BirthdaysWidget.vue?vue&type=template&id=71e297ac&scoped=true&"
import script from "./BirthdaysWidget.vue?vue&type=script&lang=js&"
export * from "./BirthdaysWidget.vue?vue&type=script&lang=js&"
import style0 from "./BirthdaysWidget.vue?vue&type=style&index=0&id=71e297ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e297ac",
  null
  
)

export default component.exports